import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    baseUrl: 'https://oe.schoolpi.net/',
    ossUrl: 'https://oss.schoolpi.net/home/',
    ids: 0,
    sidebar: {},
    SearchList: [],
    blankData: {}

  },
  mutations: {
    setSidebar (state, obj) {
      state.sidebar = obj
    },
    setIds (state, id) {
      state.ids = id
    },
    setBlankData (state, data) {
      state.blankData = data
    },
    SearchList (state, data) {
      state.SearchList = data
    }
  },

  plugins: [createPersistedState({
    key: 'saas-web',
    storage: window.sessionStorage
  })]
})
